exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".leaflet-measure-path-measurement{position:absolute;font-size:10px;color:#000;text-shadow:-1px 0 0 #fff,-1px -1px 0 #fff,0 -1px 0 #fff,1px -1px 0 #fff,1px 0 0 #fff,1px 1px 0 #fff,0 1px 0 #fff,-1px 1px 0 #fff;white-space:nowrap;transform-origin:0;pointer-events:none}.leaflet-measure-path-measurement>div{position:relative;margin-top:-25%;left:-50%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/plugins/meature/leaflet-measure-path.css
// module id = 168
// module chunks = 1